import React, { FC } from 'react';
import { Button, Checkbox, Dropdown, Tooltip } from 'antd';
import { Divider } from 'common/components';
import { Filters } from 'common/svg';
import { EUserStatus } from 'entities/User/User.enum';
import { IUserListParams } from 'entities/User/User.models';

interface IComponentProps {
  isSeller?: boolean;
  params: IUserListParams;
  onChangeFilter: (params: IUserListParams) => void;
}

export const SettingsUserFilterBtn: FC<IComponentProps> = ({ isSeller, params, onChangeFilter }) => {
  return (
    <Tooltip title="Фильтр" placement="bottom">
      <Dropdown
        overlayClassName="redesign account-user-list-settings-filter-btn__dropdown"
        trigger={['click']}
        placement="bottomRight"
        dropdownRender={() => {
          return (
            <div className="custom-dropdown" style={{ width: 324 }}>
              <Checkbox
                checked={params.status === EUserStatus.NotActive}
                onChange={(e) => onChangeFilter({ status: e.target.checked ? EUserStatus.NotActive : undefined })}
              >
                Не активированы
              </Checkbox>

              {!isSeller && (
                <>
                  <Divider marginY={8} />

                  <Checkbox
                    checked={params.withoutSubdivision}
                    onChange={(e) => onChangeFilter({ withoutSubdivision: e.target.checked ? true : undefined })}
                  >
                    Не привязаны к подразделению
                  </Checkbox>
                </>
              )}
            </div>
          );
        }}
      >
        <Button
          className={`button-circle secondary ${params.status || params.withoutSubdivision ? 'badge-active' : ''}`}
          icon={<Filters />}
        />
      </Dropdown>
    </Tooltip>
  );
};
